import { KeyValueModel } from "model";
import { EnumTpAceite } from "model/enums/enum-tp-aceite";

export const TpAceiteMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpAceite.Aceito, "Aceito"),
    new KeyValueModel(EnumTpAceite.NaoAceito, "Nâo Aceito"),
];